// extracted by mini-css-extract-plugin
module.exports = {"description":"description_description__2b_WC","title":"description_title__3Wubq","rotateColor":"description_rotateColor__1zPzH"};